import methods from './methods'
import props from './props'

export default {
  methods,
  props
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/agendas/components/resources/index.js